import store from '../../Modules/store/store';

const sidebarTrigger = document.getElementById('js-sidebar-trigger');
const appliedFiltersText = document.getElementById('js-sidebar-applied-filter-count');
const appliedFiltersValue = document.getElementById('js-sidebar-applied-filter-count-value');

function toggle() {
  // Dispatch to vuex store
  const targetState = !store.getters.expandSidebar;
  store.dispatch('setExpandSidebar', targetState);
}

function updateAppliedFilterCount(newState) {
  const show = newState > 0;
  appliedFiltersText.style.display = show ? 'inline-block' : 'none';
  appliedFiltersValue.innerHTML = newState;
}

if (sidebarTrigger) {
  window.addEventListener('load', () => {
    sidebarTrigger.addEventListener('click', toggle, false);
    if (appliedFiltersText && appliedFiltersValue) {
      updateAppliedFilterCount(store.getters.appliedFilterCount);
    }
  });

  if (appliedFiltersText && appliedFiltersValue) {
    store.watch(state => state.appliedFilterCount, updateAppliedFilterCount);
  }
}
